import React, { Suspense, lazy, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
if (typeof document !== 'undefined') {
  // 1. Preload hero image — highest priority for LCP
  const preloadImg = document.createElement('link');
  preloadImg.rel = 'preload';
  preloadImg.as = 'image';
  preloadImg.href = 'https://cdn.magicpatterns.com/uploads/kw6DKup3593a1GHCTJj47h/ChatGPT_Image_10_abr_2026,_10_10_19.jpg';
  document.head.insertBefore(preloadImg, document.head.firstChild);
  // 2. Google Fonts — non-blocking
  const fontLink = document.createElement('link');
  fontLink.rel = 'stylesheet';
  fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600&family=Poppins:wght@700;800&display=swap';
  fontLink.media = 'print';
  fontLink.onload = function () {
    ;
    (this as HTMLLinkElement).media = 'all';
  };
  document.head.appendChild(fontLink);
  // 3. Single preconnect — only fonts (CDN already connected via preload)
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = 'https://fonts.gstatic.com';
  preconnect.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect);
  // 4. Meta Pixel — deferred to not block critical path
  if (!document.querySelector('[data-meta-pixel]')) {
    requestIdleCallback?.(() => {
      const s = document.createElement('script');
      s.setAttribute('data-meta-pixel', 'true');
      s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1413771729918296');fbq('track','PageView');`;
      document.head.appendChild(s);
    }) ?? setTimeout(() => {
      const s = document.createElement('script');
      s.setAttribute('data-meta-pixel', 'true');
      s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1413771729918296');fbq('track','PageView');`;
      document.head.appendChild(s);
    }, 4000);
  }
}
const App = lazy(() => import('./App').then(m => ({
  default: m.App
})));
render(<Suspense fallback={<div className="min-h-screen bg-[#0a1628] text-center pt-16 px-4" data-id="element-319">
        <div style={{
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '6px 16px',
    borderRadius: 9999,
    background: 'rgba(59,130,246,0.1)',
    border: '1px solid rgba(59,130,246,0.2)',
    color: '#60a5fa',
    fontWeight: 600,
    fontSize: 14,
    letterSpacing: '0.05em',
    marginBottom: 16
  }} data-id="element-320">
          💙 MI MUNDO INTERIOR™
        </div>
        <h1 style={{
    fontFamily: 'Poppins,-apple-system,sans-serif',
    fontSize: 'clamp(2rem,8vw,5rem)',
    fontWeight: 800,
    lineHeight: 1.08,
    color: 'white',
    marginBottom: 8
  }} data-id="element-321">
          Todo lo que tu hijo necesita para su mundo emocional.
        </h1>
        <p style={{
    fontFamily: 'Poppins,-apple-system,sans-serif',
    fontSize: 'clamp(1.5rem,6vw,4rem)',
    fontWeight: 800,
    color: '#60a5fa'
  }} data-id="element-322">
          Listo. Desde hoy.
        </p>
      </div>} data-id="element-318">
    <App data-id="element-323" />
  </Suspense>, document.getElementById('root'));